// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"328":"admin","423":"scoring","443":"about","609":"team","996":"info"}[chunkId] + "." + {"328":"1f4628dc","423":"8d3b50e3","443":"aec67250","609":"8aa16709","996":"9e3b9b63"}[chunkId] + ".js";
};